import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useContext } from "react";
import ProfileContext from "../../utils/Context/ProfileContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const Login = () => {
  const navigate = useNavigate();
  const ProfileContextValue = useContext(ProfileContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  useEffect(() => {
    const profile = localStorage.getItem("profile");
    if (profile) {
        const { email, password, name } = JSON.parse(profile);
        setEmail(email);
        setPassword(password);
        // ProfileContextValue.updateProfile({ name });
    }
    }, []);
  const handleLogin = async () => {
    const loaderToast = toast.loading("Logging in...");

    const res = await fetch("https://tipdeso.com/attendy-login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });
    const data = await res.json();
    if (data.status === "success") {
      toast.dismiss(loaderToast);
      ProfileContextValue.updateProfile(data.data);
      toast.success("Logged in successfully");
      localStorage.setItem(
        "profile",
        JSON.stringify({
          email: email,
          password: password,
          name: data.data.name,
        })
      );
      setEmail("");
      setPassword("");
      navigate("/dashboard");
    } else {
      toast.dismiss(loaderToast);
      toast.error(data.message);
    }
  };

  return (
    <>
      <Navbar showLogin={false} />
      <Toaster />
      <div className="flex flex-col justify-center items-center mt-4 sm:mt-20 md:mt-40">
        <div className="relative text-4xl md:py-10 font-bold text-gray-800 text-center  leading-normal rounded-full z-10">
          <p className="">
            Log in to your Organization's Admin{" "}
            <span className="font-extrabold text-purple-800 decoration-purple-800 underline-offset-8 underline">
              Dashboard
            </span>
          </p>
        </div>

        <div className="flex flex-col space-y-4">
          <input
            type="text"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
          />
          <input
            type="password"
            placeholder="Set your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
          />
        </div>

        <button
          className="bg-purple-800 text-white px-12 py-3 rounded-md hover:bg-purple-900 mt-2"
          onClick={handleLogin}
        >
          Login
        </button>
        <div className="mt-2">
          <p>
            Don't have Account?{" "}
            <Link className="text-blue-500 underline" to={"/sign-up"}>
              Create Admin Account
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
